import React, { useContext, useState } from 'react';
import { ApiContext } from '../../App';
import { toast } from 'react-toastify';

const ContractUploader = ({ partnerId, onContractUpload }) => {
  const [file, setFile] = useState(null);
  const API = useContext(ApiContext);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  const handleUpload = async () => {
    if (!file) {
      alert('Please select a PDF file');
      return;
    }

    const formData = new FormData();
    formData.append('contract', file);

    try {
      const response = await API.put(`/api/partners/${partnerId}/contract`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      toast.success('Contract uploaded successfully');
      setFile(null);

      if (onContractUpload) {
        onContractUpload(response.data.contractPath);
      }
    } catch (error) {
      console.error('Contract upload failed:', error);
      toast.error('Failed to upload contract');
    }
  };

  return (
    <div className='space-x-2'>
      <input 
        type="file" 
        accept=".pdf" 
        onChange={handleFileChange} 
        
      />
          {file && (
        <>
          <button 
            onClick={handleUpload} 
            className="bg-indigo-500 text-white px-2 py-1 rounded hover:bg-indigo-600"
          >
            Upload
          </button>
        </>
      )}    </div>
  );
};

export default ContractUploader;